import CreateAccountPage from "./create-account-page";

export default CreateAccountPage;
